import { Formik } from "formik";
import React from "react";

import { LinearProgress } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { serviceProductValidationSchema } from "./helper/serviceProductValidation";
import useServiceProductForm from "./hooks/useServiceProductForm";
import ServiceProductFormContent from "./ServiceProductFormContent";
import { ApiKey, ServiceProductCreatable } from "./types";

export interface ServiceProductFormProps {
  solutionKey: Key;
  apiKeys: ApiKey[];
  availableProductServices: string[];
  onSubmit: (serviceProduct: ServiceProductCreatable) => void;
  initialValues?: Partial<ServiceProductCreatable>;
}

const useStyles = makeStyles({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
});

const ServiceProductForm: React.FC<ServiceProductFormProps> = props => {
  const {
    initialValues,
    submitForm,
    loading,
    singlePeriod,
    handleSinglePeriodChange
  } = useServiceProductForm(props);
  const classes = useStyles();

  if (loading) return <LinearProgress />;

  return (
    <div className={classes.root}>
      {initialValues && (
        <Formik
          initialValues={{
            ...initialValues,
            singlePeriod,
            solutionKey: props.solutionKey
          }}
          validationSchema={serviceProductValidationSchema}
          onSubmit={submitForm}
        >
          {formikProps => (
            <ServiceProductFormContent
              values={formikProps.values}
              setFieldValue={formikProps.setFieldValue}
              errors={formikProps.errors}
              isSubmitting={formikProps.isSubmitting}
              apiKeys={props.apiKeys}
              availableProductServices={props.availableProductServices}
              solutionKey={props.solutionKey}
              singlePeriod={singlePeriod}
              handleSinglePeriodChange={handleSinglePeriodChange}
            />
          )}
        </Formik>
      )}
    </div>
  );
};

export default ServiceProductForm;
